import * as React from 'react';
import {
  createStyles, DialogActions, Grid, Switch, TextField, Theme, withStyles,
} from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
// @ts-ignore
import CancelButton from 'hcla-web-frontend-primitives/app/components/primitives/Buttons/CancelButton';
// @ts-ignore
import CreateButton from 'hcla-web-frontend-primitives/app/components/primitives/Buttons/CreateButton';

import NodeLabelChip, { NodeLabelChipProps } from '../NodeLabel/NodeLabelChip';
import { FaultTreeMxGraphJSON } from '../../../../mxGraph/HCLTreeMxGraph/FaultTreeMxGraph';
import HclApiManager from '../../../../Api/HclApiManager';
import { TreeTypes } from '../../SingleHCLModelView/SingleTreeView/Tools/TreeDictionaries';
import { QuantificationResultJSON } from '../../Quantification/QuantificationResultJSON';
import QuantificationResultComparisonModal from '../../SingleHCLModelView/SingleTreeView/Quantification/QuantificationResultComparisonModal';
import CutsetComparisonView from '../CutsetComparisonView';
import { QuantificationResultContext } from '../../SingleHCLModelView/SingleTreeView/Quantification/QuantificationResultModal';
import ImportanceMeasureComparisonView from "../ImportanceMeasures/Comparison/ImportanceMeasureComparisonView";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import RiskMitigationDialog from "../../RiskMitigation/RiskMitigationDialog";
import FailureModeDialog from "../../RiskMitigation/FailureModeDialog";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import InputRules from "../../SingleHCLModelView/SingleTreeView/Inputs/InputRules";
import CloseIcon from '@material-ui/icons/Close';
import TypedConfirmationDialog from 'hcla-web-frontend-primitives/app/components/primitives/Dialogs/TypedConfirmationDialog';

export interface BasicEventRMChipProps extends NodeLabelChipProps {
  dialogProps?: DialogProps;
  prevQuantificationResult: QuantificationResultJSON;
  classes?: any;
  treeId: number;
}

interface State {
  portalOpen: boolean;
  selectedFailureModes: {};
  userFailureModes: any;
  userMitigations: any;
  risk_mitigations: any;
  dialog: any;
  factor: number;
  tree: FaultTreeMxGraphJSON | null;
  originalTree: FaultTreeMxGraphJSON | null;
  modalOpen: false;
  quantificationResult: QuantificationResultJSON;
  quantifying: false;
}

const alphas = [
  [0.1, 0.2],
  [0.02, 0.34],
  [0.08, 0.79],
  [0.10, 0.093],
  [0.98, 0.35],
  [0.730, 0.268],
  [0.02, 0.34],
  [0.08, 0.79],
  [0.10, 0.093],
  [0.98, 0.35],
  [0.730, 0.268],
  [0.02, 0.34],
  [0.08, 0.79],
  [0.10, 0.093],
  [0.98, 0.35],
];
const styles = (theme: Theme) => createStyles({
  container: {
    textAlign: 'center',
  },
  table: {
    borderCollapse: 'collapse',
    overflow: 'auto',
  },
  row: {
    '&:hover': {
      background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
    },
  },
  probField: {
    width: 48,
  },
  item: {
    position: 'relative',
    '&:hover::after': {

    },
  },
  header: {
    position: 'relative',
    padding: `${theme.spacing(2)}px`,
  },
  mitigationHeader: {
    position: 'relative',
    padding: `${theme.spacing(2)}px`,
    minWidth: '200px'
  },
  failureModeItem: {
    minWidth: '200px'
  },
  col: {
    '&:hover': {
      background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
  },
});


class BasicEventRMChip extends React.Component<BasicEventRMChipProps, State> {
  constructor(props: BasicEventRMChipProps) {
    super(props);
    this.state = {
      portalOpen: false,
      tree: null,
      originalTree: null,
      selectedFailureModes: {},
      userFailureModes: ['Failure Mode A'],
      userMitigations: ['Mitigation I'],
      risk_mitigations: [],
      dialog: null,
      modalOpen: false,
      quantificationResult: null,
      quantifying: false,
    };
  }

  private factor = () => {
    const { risk_mitigations } = this.state;
    let value = 1;
    risk_mitigations.forEach((item) => {
      const val = Number(item.value);
      if (!Number.isNaN(val)) {
        value *= (1 - val);
      }
    });
    return value;
  };

  private handleClose = () => {
    this.setState({ portalOpen: false });
  };

  private shouldApplyBeDisabled = () => {
    const { selectedFailureModes, risk_mitigations } = this.state;
    return Object.keys(selectedFailureModes).length === 0 ||
      Object.keys(selectedFailureModes).some((key) => selectedFailureModes[key].selected === false) ||
      risk_mitigations.length === 0 ||
      risk_mitigations.some((item) => !InputRules.isProbabilityValid(item.value));
  }

  private handleOpen = (e: React.SyntheticEvent<{}, Event>) => {
    const { map, name } = this.props;
    HclApiManager.getHclTreeWithMetadata(map[name].tree_id)
      .then(response => response.ok && response.json())
      .then((data) => {
        this.setState({ portalOpen: true, tree: data, originalTree: data });
      });
  };

  private handleQuantifyTree = (e) => {
    const { tree, tree: { tree_data, tree_data: { basic_events} }, originalTree } = this.state;
    const { map, name, treeId } = this.props;
    const key = map[name].name;
    if (!tree) {
      this.handleClose();
    }
    this.setState({
      tree: {
        ...tree,
        tree_data: {
          ...tree_data,
          basic_events: {
            ...basic_events,
            [key]: {
              ...basic_events[key],
              expression: {
                _proxy: 'Float',
                value: this.factor() * basic_events[key].expression.value,
              },
            },
          },
        },
      },
    }, () => {
      HclApiManager.patchHclTreeDataOnlyJson(map[name].tree_id, TreeTypes.FAULT_TREE, this.state.tree.tree_data)
        .then((res: any) => {
          return res.json();
        })
        .then((data) => {
          const configs = JSON.parse(localStorage.getItem('configurations'));
          const currentName = configs.currentlySelected;
          const currentConfig = configs.configurations[currentName];
          HclApiManager.quantifyHCLTreeWithSettings(this.state.tree.model.id, treeId, currentConfig,
            {
              successText: 'Quantification Successful',
              failText: 'Quantification Failed',
            },
            // @ts-ignore
            res => res.status === 201 && res.json()
              .then((data: QuantificationResultJSON) => {
                this.setState(
                  {
                    modalOpen: true,
                    quantificationResult: data,
                    quantifying: false,
                  },
                );
              }),
            () => this.setState(
              {
                modalOpen: false,
                quantificationResult: null,
                quantifying: false,
              },
            ));
        })
        .then(() => {
          HclApiManager.patchHclTreeDataOnlyJson(map[name].tree_id, TreeTypes.FAULT_TREE, originalTree.tree_data)
            .then((res: any) => res.json())
            .then(() => this.setState({ tree: originalTree }))
        });
    });
  }

  private handlePatchTree = () => {
    const { tree, tree: { tree_data, tree_data: { basic_events} }, risk_mitigations} = this.state;
    const { map, name, treeId } = this.props;
    const key = map[name].name;
    if (!tree) {
      this.handleClose();
    }
    this.setState({
      tree: {
        ...tree,
        tree_data: {
          ...tree_data,
          basic_events: {
            ...basic_events,
            [key]: {
              ...basic_events[key],
              expression: {
                _proxy: 'Float',
                value: this.factor() * basic_events[key].expression.value,
              },
            },
          },
          risk_mitigations: [...risk_mitigations]
        },
      },
    }, () => {
      HclApiManager.patchHclTreeDataOnlyJson(map[name].tree_id, TreeTypes.FAULT_TREE, this.state.tree.tree_data)
        .then((res: any) => res.json())
        .then(() => this.handleClose())
    });
  }

  private static getLabelName = (map, name) => {
    try {
      return map[name].label.name;
    } catch (e) {
      console.error(e);
      return 'Undefined';
    }
  }

  private renderNewMitigationDialog = () => {
    const { userMitigations } = this.state;
    this.setState({
      dialog: (
        <RiskMitigationDialog
          create={(newMitigation: string) => this.setState({
            userMitigations: [...userMitigations, newMitigation],
            dialog: null
          })}
          close={() => this.setState({dialog: null})}
        />
      )
    })
  }

  private renderNewFailureModeDialog = () => {
    const { userFailureModes } = this.state;
    this.setState({
      dialog: (
        <FailureModeDialog
          create={(newFailureMode: string) => this.setState({
            userFailureModes: [...userFailureModes, newFailureMode],
            dialog: null
          })}
          close={() => this.setState({dialog: null})}
        />
      )
    })
  }

  private handleMitigationTextChange = (e: React.SyntheticEvent<{}, Event>, mitigationIndex: number) => {
    const { userMitigations, risk_mitigations } = this.state;
    this.setState({
      userMitigations: userMitigations.map((item: string, idx: number) => {
        return idx === mitigationIndex ? String(e.target.value) : item;
      }),
      risk_mitigations: risk_mitigations.length === 0 ? risk_mitigations : risk_mitigations.map((item: any, idx: number) => {
        if (idx === mitigationIndex)
          return {
            ...item,
            mitigation_name: String(e.target.value)
          }
        else
          return {...item}
      })
    })
  }

  private handleFailureModeTextChange = (e: React.SyntheticEvent<{}, Event>, failureModeIndex: number) => {
    const { userFailureModes, risk_mitigations, selectedFailureModes } = this.state;
    const newFailureModes: any = {};
    if (Object.keys(selectedFailureModes).length !== 0) {
      for (const key of Object.keys(selectedFailureModes)) {
        if (selectedFailureModes[key].id === failureModeIndex) {
          newFailureModes[e.target.value] = selectedFailureModes[key];
        } else {
          newFailureModes[key] = selectedFailureModes[key];
        }
      }
    }
    this.setState({
      userFailureModes: userFailureModes.map((item: string, idx: number) => {
        return idx === failureModeIndex ? String(e.target.value) : item;
      }),
      risk_mitigations: risk_mitigations.length === 0 ? risk_mitigations : risk_mitigations.map((item: any, idx: number) => {
        if (idx === failureModeIndex)
          return {
            ...item,
            failure_mode: String(e.target.value)
          }
        else
          return {...item}
      }),
      selectedFailureModes: newFailureModes
    })
  }

  private handleDeleteMitigation = (mitigationIndex: number) => {
    const { userMitigations, risk_mitigations } = this.state;
    this.setState({
      userMitigations: userMitigations.filter((item: string, idx: number) => idx !== mitigationIndex),
      risk_mitigations: risk_mitigations.length === 0 ? risk_mitigations : risk_mitigations.filter((item: any, idx: number) => {
        if (idx !== mitigationIndex) return {...item}
      })
    })
  }

  private handleDeleteFailureMode = (failureModeIndex: number) => {
    const { userFailureModes, selectedFailureModes, risk_mitigations } = this.state;
    const newFailureModes: any = {};
    for (const key of Object.keys(selectedFailureModes)) {
      if (selectedFailureModes[key].id !== failureModeIndex) newFailureModes[key] = selectedFailureModes[key];
    }
    this.setState({
      userFailureModes: userFailureModes.filter((item: string, idx: number) => idx !== failureModeIndex),
      risk_mitigations: risk_mitigations.length === 0 ? risk_mitigations : risk_mitigations.filter((item: any, idx: number) => {
        if (idx !== failureModeIndex) return {...item}
      }),
      selectedFailureModes: newFailureModes
    })
  }

  private handleValueUpdate = (e: React.SyntheticEvent<{}, Event>, mitigationName: string, failureMode: string) => {
    const { risk_mitigations } = this.state;
    let riskMitigationsCopy = [...risk_mitigations];
    const riskMitigationIndex = riskMitigationsCopy.findIndex((item) => item.failure_mode === failureMode && item.mitigation_name === mitigationName);
    riskMitigationsCopy = riskMitigationIndex !== -1 ? riskMitigationsCopy.map((item, idxrm) => {
      if (idxrm === riskMitigationIndex ) {
        return {
          ...item,
          value: Number(e.target.value)
        }
      } else {
        return {...item}
      }
    }) : riskMitigationsCopy.concat({
      failure_mode: failureMode,
      mitigation_name: mitigationName,
      value: Number(e.target.value)
    });
    this.setState({
      risk_mitigations: riskMitigationsCopy
    });
  }

  render() {
    const { dialog, portalOpen, factor, quantificationResult, quantifying, risk_mitigations, userFailureModes, userMitigations, selectedFailureModes } = this.state;
    const {
      dialogProps, classes, classes: {
        row, col, container, table, header, item, probField,
      }, map, name, ...others
    } = this.props;
    return (
      <React.Fragment>
        {dialog}
        {/*
        // @ts-ignore */}
        <NodeLabelChip map={map} name={name} {...others} onClick={this.handleOpen} />
        <Dialog
          {...dialogProps}
          open={portalOpen}
          maxWidth="md"
          fullWidth
          onClose={this.handleClose}
          disablePortal
        >
          <DialogTitle>
            <Typography variant="h5" color="textPrimary">Risk Mitigations</Typography>
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="h6" color="textSecondary">{BasicEventRMChip.getLabelName(map, name)}</Typography>
              </Grid>
              <Grid item xs={6} style={{ textAlign: 'right'}}>
                <Button style={{ textTransform: 'none' }} color={"primary"} startIcon={<AddCircleIcon/>} variant={"contained"} onClick={this.renderNewMitigationDialog}><Typography>Add Mitigation</Typography></Button>
                <Button style={{ textTransform: 'none' }} color={"secondary"} startIcon={<AddCircleIcon/>} variant={"contained"} onClick={this.renderNewFailureModeDialog}><Typography>Add Failure Mode</Typography></Button>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <Grid container className={container}>
              <table className={table}>
                <tr className={row}>
                  <th className={header} />
                  <th className={header} />
                  {
                    userMitigations.map((mitigation: string, userMitigationIndex: number) => (
                      <th className={classes.mitigationHeader}>
                        <TextField
                          value={mitigation}
                          onChange={(e) => this.handleMitigationTextChange(e, userMitigationIndex)}
                          InputProps={{
                            endAdornment: <IconButton onClick={() => this.handleDeleteMitigation(userMitigationIndex)}><CloseIcon /></IconButton>
                          }}
                        />
                      </th>
                    ))
                  }
                </tr>
                {
                  userFailureModes.map((mode, idxf) => {
                    const t = (
                      <React.Fragment>
                        <td>
                          <Switch onChange={(event) => {
                            this.setState({
                              selectedFailureModes: {
                                ...selectedFailureModes,
                                [mode]: {
                                  selected: (event.target.checked),
                                  id: idxf
                                },
                              },
                            });
                          }}
                          >
                            {mode}
                          </Switch>
                        </td>
                        <td className={classes.failureModeItem}>
                          <TextField
                            value={mode}
                            onChange={(e) => this.handleFailureModeTextChange(e, idxf)}
                            InputProps={{
                              endAdornment: <IconButton onClick={() => this.handleDeleteFailureMode(idxf)}><CloseIcon /></IconButton>
                            }}
                          />
                        </td>
                      </React.Fragment>
                    );
                    const m = userMitigations.map((mitigation, idxm) => (
                      <td className={item}>
                        <TextField
                          color="primary"
                          default={0}
                          className={probField}
                          disabled={selectedFailureModes[mode] && !(selectedFailureModes[mode].selected)}
                          onChange={(event: React.SyntheticEvent) => this.handleValueUpdate(event, userMitigations[idxm], userFailureModes[idxf])}
                        />
                      </td>
                    ));
                    m.unshift(t);
                    return <tr className={row}>{m}</tr>;
                  })
                }
              </table>
              <Grid container>
                <Grid item xs={12}>
                  <TextField value={(this.factor()).toFixed(3)} />
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CancelButton
              variant="outlined"
              onClick={this.handleClose}
              size="large"
            >
              Cancel
            </CancelButton>
            <ButtonGroup>
              <CreateButton
                variant="outlined"
                onClick={this.handleQuantifyTree}
                size="large"
              >
                Quantify
              </CreateButton>
              <CreateButton
                variant="outlined"
                // onClick={this.handlePatchTree}
                onClick={() => this.setState({
                  dialog: (
                    <TypedConfirmationDialog
                      title={"Risk Mitigation Confirmation"}
                      content={(
                        <div>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color={"primary"}
                          >
                            You're about to apply Risk Mitigations to your model, are you sure this is what you want to do? These changes cannot be undone.
                          </Typography>
                          <Typography variant="body1">
                            Type "Yes" in the text field below to proceed.
                          </Typography>
                        </div>
                      )}
                      open={true}
                      onConfirmed={() => this.setState({ dialog: null}, () => this.handlePatchTree())}
                      onRequestClose={() => this.setState({ dialog: null })}
                      matchText={"Yes"}
                      confirmationBtnText={"Apply"}
                    />
                  )
                })}
                size="large"
                disabled={this.shouldApplyBeDisabled()}
              >
                Apply
              </CreateButton>
            </ButtonGroup>
          </DialogActions>
        </Dialog>
        <Dialog
          maxWidth={false}
          open={this.state.modalOpen}
          PaperProps={{
            square: true,
          }}
          fullWidth
          scroll="paper"
          onClose={e => this.setState({ modalOpen: false })}
        >
          <QuantificationResultContext.Consumer>
            {
              (value: any) => {
                const cutsetView = value.detail && quantificationResult ? <CutsetComparisonView resultDataA={value.detail.result_data} resultDataB={quantificationResult.result_data} type={quantificationResult.configuration.quantify.type} /> : <div />;
                const getImportanceView = () => {
                  if (quantificationResult.result_data && quantificationResult.result_data.importance) {
                    // @ts-ignore
                    return (<ImportanceMeasureComparisonView noSlide loading={quantifying} dataA={value.detail} dataB={quantificationResult} map={value.detail.result_data.label_map} treeType />);
                  }
                  return (
                    <div className={classes.root}>
                      <Typography variant="h5" align="center" color="textSecondary" paragraph>
                        No Importance Measures Specified
                      </Typography>
                    </div>
                  );
                };
                return (
                  <QuantificationResultComparisonModal
                    treeTitle="Compare Quantification Results"
                    cutsetView={cutsetView}
                    measureView={getImportanceView()}
                    detailA={value.detail}
                    detailB={this.state.quantificationResult}
                    requestClose={e => this.setState({ modalOpen: false })}
                  />
                );
              }
            }
          </QuantificationResultContext.Consumer>
        </Dialog>

      </React.Fragment>
    );
  }
}

export default withStyles(styles)(BasicEventRMChip);
